import { useCallback, useEffect, useMemo, useState } from 'react';
import { labelPrintersApi } from '../lib/api';
import { getStoredDefaultPrinterId, setStoredDefaultPrinterId } from '../lib/labelPrinter';

export function useLabelPrinters() {
  const [printers, setPrinters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(getStoredDefaultPrinterId());

  const load = useCallback(async () => {
    try {
      const res = await labelPrintersApi.list();
      const rows = res.data || [];
      setPrinters(rows);
      const stored = getStoredDefaultPrinterId();
      const defaultRow = rows.find((p) => p.id === stored) || rows.find((p) => p.is_default) || rows[0];
      if (defaultRow && !stored) {
        setSelectedId(defaultRow.id);
      }
    } catch {
      setPrinters([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const selectedPrinter = useMemo(
    () => printers.find((p) => p.id === selectedId) || null,
    [printers, selectedId],
  );

  const selectPrinter = useCallback((id) => {
    setSelectedId(id);
    setStoredDefaultPrinterId(id);
  }, []);

  return { printers, loading, selectedPrinter, selectedId, selectPrinter, reload: load };
}
